import { getThemeCssVars } from "$root/utils";
import { IconButton } from "@mdotm/shadcn/mdotm/components";
import { Text } from "@mdotm/shadcn/legacy/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import Color from "color";
import type { MouseEvent } from "react";

type TagBadgeProps = { grey?: boolean; label: string; color?: string; onRemove?(e: MouseEvent): void };

export function TagBadge({ color, label, grey = false, onRemove }: TagBadgeProps): React.JSX.Element {
	const backgroundColor = grey
		? getThemeCssVars(themeCSSVars.palette_N50)
		: (color ?? getThemeCssVars(themeCSSVars.palette_N50));
	const foregroundColor =
		Color(Color("#ffffff")).contrast(Color(backgroundColor)) > 3 ? themeCSSVars.palette_N0 : themeCSSVars.palette_N900;

	return (
		<div
			className="px-1 py-0.5 rounded-sm shrink-0 leading-none flex gap-1 items-center w-fit h-fit"
			style={{
				backgroundColor,
				color: foregroundColor,
			}}
		>
			<Text type="Body/S/Medium">{label}</Text>
			{onRemove && (
				<IconButton
					icon="Close"
					onClick={onRemove}
					size="12"
					background={backgroundColor}
					color={themeCSSVars.palette_N800}
					hoverBackground={Color(backgroundColor).darken(0.1).hex()}
					className="p-0.5! -m-0.5! shrink-0"
				/>
			)}
		</div>
	);
}
